import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Using Record<string, any> to allow any properties on the subject area items

interface SubjectAreaItem {
  Id: string; // Adjust the type as needed
  DisplayName?: string;
}

interface CreateSubjectAreaData {
  id: string;
  activeStep: number;
  subjectArea: SubjectAreaItem[];
}
const initialState: CreateSubjectAreaData = {
  id: "",
  activeStep: 0,
  subjectArea: [],
};

const subjectAreaSlice = createSlice({
  name: "SubjectAreaRequest",
  initialState,
  reducers: {
    setSubjectAreaRequestId: (state, action: PayloadAction<string>) => {
      state.id = action.payload; // Update the id in the state
    },
    setSubjectAreaRequestData: (
      state,
      action: PayloadAction<SubjectAreaItem[]>
    ) => {
      state.subjectArea = action.payload; // Update the id in the state
    },

    setActiveStep: (state, action: PayloadAction<number>) => {
      state.activeStep = action.payload; // Update the id in the state
    },

    reset: () => initialState,
  },
});

export const {
  setSubjectAreaRequestId,
  setSubjectAreaRequestData,
  setActiveStep,
  reset,
} = subjectAreaSlice.actions;
export default subjectAreaSlice.reducer;
